import { getRequest, postRequest } from "../config/AxiosConfig";
import API_URLS from "../config/BackendConfig";
import { getAuthToken } from "../utils/tokenUtils";

export const getWebLeadReport = async (payload = {}) => {
  try {
    const token = getAuthToken();

    // Remove empty/undefined filter properties so they don't bloat the URL
    const cleanedParams = Object.fromEntries(
      Object.entries(payload).filter(
        ([_, value]) => value !== "" && value !== null && value !== undefined
      )
    );

    const res = await getRequest({
      url: API_URLS.ADMIN + `enquiry/report`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      params: cleanedParams, // Passes object as GET query parameters (?type=Lead&from_date=2026-09-01...)
    });

    return res;
  } catch (error) {
    console.error("Service Error:", error);
    return error?.response || error;
  }
};

export const getEmpWebLeadReport = async (payload = {}) => {
  try {
    const token = getAuthToken();

    // Remove empty/undefined filter properties so they don't bloat the URL
    const cleanedParams = Object.fromEntries(
      Object.entries(payload).filter(
        ([_, value]) => value !== "" && value !== null && value !== undefined
      )
    );

    const res = await postRequest({
      url: API_URLS.ADMIN + `assigned-report`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: cleanedParams, // Passes object as GET query parameters (?type=Lead&from_date=2026-09-01...)
    });

    return res;
  } catch (error) {
    console.error("Service Error:", error);
    return error?.response || error;
  }
};

export const assignLead = async (payload = {}) => {
  try {
    const token = getAuthToken();

    const res = await postRequest({
      url: API_URLS.ADMIN + `enquiry/assign`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: payload, // Passes object as GET query parameters (?type=Lead&from_date=2026-09-01...)
    });

    console.log("Web Lead Report Response:", res);

    return res;
  } catch (error) {
    console.error("Service Error:", error);
    return error?.response || error;
  }
};

export const changeLeadStatus = async (payload = {}) => {
  try {
    const token = getAuthToken();

    const res = await postRequest({
      url: API_URLS.ADMIN + `update-assigned/status`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: payload, // Passes object as GET query parameters (?type=Lead&from_date=2026-09-01...)
    });

    console.log("Web Lead Report Response:", res);

    return res;
  } catch (error) {
    console.error("Service Error:", error);
    return error?.response || error;
  }
};